import { transformDropbox } from "@/lib/mapper/images";
import { resolveInputValue } from "@/modules/_shared/templateValue";
import type { CellModule } from "@/modules/_shared/contract";

export const dropboxImageModule: CellModule = {
  kind: "dropbox-image",
  capability: "cell",
  name: "Dropbox Image Links",
  tooltip: "Turn a Dropbox share link into a direct, downloadable URL",
  description:
    "Takes a Dropbox share URL from a column and rewrites it to a direct download URL that Shopify (and other marketplaces) accept. Use its output on any image field.",
  category: "Images",
  tags: ["dropbox", "image", "url", "link", "direct", "download", "shopify"],
  icon: { kind: "lucide", name: "ImageDown" },
  tone: "teal",
  defaultConfig: () => ({ kind: "dropbox-image", input: "" }),
  resolve: (rule, { row, helpers, output }) => {
    if (rule.kind !== "dropbox-image") return "";
    const input = resolveInputValue(rule.input, { row, helpers, output });
    if (!input) return "";
    return transformDropbox(input);
  },
  templateStrings: (rule) =>
    rule.kind === "dropbox-image" ? [rule.input] : [],
};
